<template>
    <div ref="editor"></div>
</template>

<script>

export default {
    props: [
        'value',
    ],
    data(){return{
        codemirror: null,
    }},
    mounted(){
        this.codemirror = CodeMirror(this.$refs['editor'], {
            theme: 'material',
            lineNumbers: true,
            mode: 'markdown',
            value: this.value || '',
        })
        this.codemirror.on('change', this.change)
    },
    methods: {
        change() {
            this.$emit('change', this.codemirror.getValue())
        },
    },
}
</script>
<style>
    .CodeMirror {
        font-size: 14px;
        padding: 15px 10px;
        height: auto;
    }
</style>
